import React, {useState} from 'react';
import {useQuery} from "react-query";
import useApi from "../../hooks/useApi/useApi";
import {IEvent, IPagedEventList} from "../../ModelContracts";
import EventCard from "../EventCard/EventCard";
import {Alert} from "../ui";
import {Link} from "react-router-dom";

interface IProps {
	boardId: string
}

function RecentBoardEvents({boardId}: IProps) {
	const [events, setEvents] = useState<Array<IEvent>>([]);
	const [moreToLoad, setMoreToLoad] = useState<boolean>(false);

	const {getBoardEvents} = useApi();
	useQuery<IPagedEventList>(
		['board-events', boardId],
		() => getBoardEvents(boardId),
		{
			onSuccess: (boardEvents: IPagedEventList) => {
				setEvents(boardEvents.items);
				setMoreToLoad(boardEvents.total > boardEvents.items.length);
			}
		}
	);

	return (
		<div>
			<h4 className="text-lg font-semibold mb-4">Recent Events</h4>
			{
				!events.length &&
				<Alert variant="secondary">No activity on this board yet.</Alert>
			}
			<div className="flex flex-col gap-2">
				{
					events.map((boardEvent, i) => (
						<EventCard key={`board-event-${i}`} event={boardEvent} maxLength={42} />
					))
				}
			</div>
			{
				moreToLoad &&
				<Link to={`/boards/${boardId}/channel`} className="btn btn-ghost btn-sm btn-block mt-4">
					<i className="bi bi-chevron-right"></i>
					View All
				</Link>
			}
		</div>
	);
}

export default RecentBoardEvents;
